import { createContext, useContext } from 'react';
const tokenPropertiesInitialValue = {
    clientId: undefined,
    entities: [],
    entitySegments: {},
    permissions: [],
    sub: '',
    subEntityId: undefined,
    userId: '',
    userRoles: [],
    userType: 'External',
};
const initialValue = {
    actions: {},
    loading: false,
    tokenProperties: tokenPropertiesInitialValue,
};
export const ClientTokenContext = createContext(initialValue);
export const useClientTokenManager = () => {
    const context = useContext(ClientTokenContext);
    return context;
};
